module.exports = __webpack_public_path__ + "img/yundonghuwai.fe0b974e.png";